<template>
  <div class="wrapper">
    <div class="wrapper-tags-pagination">
      <div class="menu-block">
        <AddContact @fetchContacts="fetchContacts"/>
<!--        <TabsMenu />-->
      </div>
      <div class="tabs-block"><ContactTabsContainer /></div>
      <div class="pagination-block"><Pagination /></div>
    </div>
    <div class="Rtable Rtable--5cols Rtable--collapse">
      <div class="Rtable-row Rtable-row--head">
        <div class="Rtable-cell cb-cell column-heading">
          <input type="checkbox" />
        </div>
        <div class="Rtable-cell img-cell column-heading">
          Image
        </div>
        <div class="Rtable-cell company-cell column-heading">
          Company
<!--          <multi-select-->
<!--            :background="{-->
<!--              mainBg: 'background: white;',-->
<!--              btnBg: 'background-color: black; border-color: none;',-->
<!--              color: 'black'-->
<!--            }"-->
<!--            :expandToRight="true"-->
<!--            :query-object="{}"-->
<!--            :sector="'finance_total'"-->
<!--            :selected-main-tab="'finance'"-->
<!--          ></multi-select>-->
        </div>
        <div class="Rtable-cell name-cell column-heading">
          Name
<!--          <multi-select-->
<!--            :background="{-->
<!--              mainBg: 'background: white;',-->
<!--              btnBg: 'background-color: black; border-color: none;',-->
<!--              color: 'black'-->
<!--            }"-->
<!--            :expandToRight="true"-->
<!--            :query-object="{}"-->
<!--            :sector="'finance_total'"-->
<!--            :selected-main-tab="'finance'"-->
<!--          ></multi-select>-->
        </div>
        <div class="Rtable-cell sms-cell column-heading">
          <multi-select
            :background="{
              mainBg: 'background: white;',
              btnBg: 'background-color: black; border-color: none;',
              color: 'black'
            }"
            :expandToRight="true"
            :query-object="{}"
            :sector="'finance_total'"
            :selected-main-tab="'finance'"
          ></multi-select>
        </div>
        <div class="Rtable-cell phone-cell column-heading">
          <multi-select
            :background="{
              mainBg: 'background: white;',
              btnBg: 'background-color: black; border-color: none;',
              color: 'black'
            }"
            :expandToRight="true"
            :query-object="{}"
            :sector="'finance_total'"
            :selected-main-tab="'finance'"
          ></multi-select>
        </div>
        <div class="Rtable-cell email-cell column-heading">
          <multi-select
            :background="{
              mainBg: 'background: white;',
              btnBg: 'background-color: black; border-color: none;',
              color: 'black'
            }"
            :expandToRight="true"
            :query-object="{}"
            :sector="'finance_total'"
            :selected-main-tab="'finance'"
          ></multi-select>
        </div>
        <div class="Rtable-cell country-cell column-heading">
          <multi-select
            :background="{
              mainBg: 'background: white;',
              btnBg: 'background-color: black; border-color: none;',
              color: 'black'
            }"
            :expandToRight="true"
            :query-object="{}"
            :sector="'finance_total'"
            :selected-main-tab="'finance'"
          ></multi-select>
        </div>
        <div class="Rtable-cell client-cell column-heading">
          <multi-select
            :background="{
              mainBg: 'background: white;',
              btnBg: 'background-color: black; border-color: none;',
              color: 'black'
            }"
            :expandToRight="true"
            :query-object="{}"
            :sector="'finance_total'"
            :selected-main-tab="'finance'"
          ></multi-select>
        </div>
        <div class="Rtable-cell plus-cell column-heading"></div>
        <div class="Rtable-cell tags-cell column-heading"></div>
      </div>
      <Contact
        v-for="contact in contacts"
        :key="contact.id"
        :columnSize="columnSize"
          :contact="contact"
      />
    </div>
  </div>
</template>

<script>
import Contact from "../components/Contact.component";
import ContactTabsContainer from "@/features/projects.feature/contacts/containers/ContactTabsContainer";
// import TabsMenu from "../components/TabsMenu.component";
import Pagination from "../components/Pagination.component";
import MultiSelect from "../../../company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/MultiSelect.container";
import AddContact from "../components/AddContactForm/AddContact.component";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "ContactsTable",
  components: {
    AddContact,
    Pagination,
    // TabsMenu,
    ContactTabsContainer,
    Contact,
    MultiSelect
  },
  props:{
    queryObject:{
      type: Object
    },
  },
  data() {
    return {
      contacts: [],
      columnSize: {}
    };
  },
  methods:{
    fetchContacts(){
      apiClientCreator("projects/contacts/list")
          .get("", { params: this.queryObject })
          .then(res => {
            this.contacts = res.data.data;
          });
    },
  },
  created() {
    this.fetchContacts()

  },
  mounted() {
    // this.fetchContacts()
  }
};
</script>

<style scoped lang="scss">
$breakpoint: 750px;
$heading-color: white;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  height: 410px;
  //max-width: 1000px;
  //margin: 1em auto;
  //padding: 1em;
}

.is-striped {
  background-color: rgba(233, 200, 147, 0.2);
}

/* Table column sizing
================================== */
.cb-cell {
  width: 3%;
}
.img-cell{
  width: 3%;
}
.company-cell {
  width: 7%;
}
.name-cell {
  width: 7%;
}
.sms-cell {
  width: 5%;
}
.phone-cell {
  width: 7%;
}
.email-cell {
  width: 5%;
}
.country-cell {
  width: 5%;
}
.client-cell {
  width: 5%;
}
.plus-cell {
  width: 3%;
}
.tags-cell {
  width: 50%;
}

/* Apply styles
================================== */
.Rtable {
  display: flex;
  flex-wrap: wrap;
  //margin: 0 0 3em 0;
  padding: 0;
  //box-shadow: 0 0 40px rgba(0,0,0,0.2);

  .Rtable-row {
    width: 100%;
    display: flex;

    .Rtable-cell {
      box-sizing: border-box;
      flex-grow: 1;
      //padding: 0.8em 1.2em;
      padding: 1% 1%;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        //color: white;
        padding: 0.5em;
        border-bottom: 2px solid #d7d7d7;
        border-top: 2px solid #d7d7d7;
      }

      .Rtable-cell--heading {
        display: none;
      }

      .Rtable-cell--content {
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
//@media wrapper-tags-pagination and (max-height: 50px) {
//  .wrapper-tags-pagination{
//    flex-direction: column;
//    height: fit-content;
//  }
//}
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .Rtable--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .Rtable-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .Rtable-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .Rtable-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .topic-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .Rtable-cell--content {
        padding-left: 0 !important;
      }
    }

    .Rtable-row--head {
      display: none;
    }
  }

  .wrapper-tags-pagination {
    flex-direction: column;
    height: fit-content !important;
  }
}

// Non-Flex modernizer fallback
.no-flexbox .Rtable {
  display: block;

  &.Rtable-cell {
    width: 100%;
  }
}
.wrapper-tags-pagination {
  display: flex;
  height: 50px;
}

.menu-block {
  flex: 2;
}
.tabs-block {
  flex: 17;
}
.pagination-block {
  flex: 2;
  padding-bottom: 10px;
}
.input-main-multi-select {
  position: relative;
  display: inline-block;
  border: 1px solid #d7d7d7;
  height: 30px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  text-transform: capitalize;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  min-width: 100%;
}
</style>
